export const appHead = {"meta":[{"charset":"utf-8"},{"name":"description","content":"Соревнования, тренировочные сборы, мастер-классы, методическое обеспечение подготовки"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"property":"og:type","content":"website"},{"property":"og:title","content":"Технология спорта | swim4you.ru"},{"property":"og:description","content":"Соревнования, тренировочные сборы, мастер-классы, методическое обеспечение подготовки"}],"link":[],"style":[],"script":[],"noscript":[],"htmlAttrs":{"lang":"ru"},"title":"Технология спорта | swim4you.ru"}

export const appPageTransition = {"name":"page","mode":"out-in"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetch":false,"componentName":"NuxtLink","prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false